(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'LivePlannerProcessor',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		// if ($('#lp-session-dates') !== undefined && $('#lp-session-dates').val().length > 0) {
		// 	$('#liveplannerprocessor-dates').val($('#lp-session-dates').val());
		// }

		$('#send-dates').off().on('click', function _sendDates(e) {
			var start_date       = '',
				end_date         = '',
				all_dates        = '',
				cruise_line_id   = '',
				page_guide_links = [];

			e.preventDefault();

			all_dates  = $('#liveplannerprocessor-dates').val().split(' - ');
			start_date = formatDate(all_dates[0]);
			end_date   = formatDate(all_dates[1]);

			Adzuki.Ajax.get('/LivePlanner/sendDates/' + start_date + '/' + end_date)
			.then(function _sendDates(content) {
				// need to make sure page links are cleared when the search is ran
				$('#page_guide').val(page_guide_links);

				Adzuki.LivePlanner.setPageGuide();

				toastr.success(
					null,
					'Dates set',
					{
						positionClass  : 'toast-top-center',
						timeOut        : 3000,
						extendedTimeOut: 0,
					}
				);

				if ($('#liveplannerprocessor-cruise_line_id') && $('#liveplannerprocessor-cruise_line_id').val().length > 0) {
					cruise_line_id = $('#liveplannerprocessor-cruise_line_id').val();

					$('.live-planner-container').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Updating sailings...');

					Adzuki.Ajax.get('/LivePlanner/sailings/' + cruise_line_id)
					.then(function _backToSailings(content) {
						$('.live-planner-container').html(content);

						Adzuki.Form.initAjaxForm('LivePlannerProcessor');
						Adzuki.LivePlanner.refreshLog();
					});
				} else {
					Adzuki.Form.initAjaxForm('LivePlannerProcessor');
				}
			});
		});

		$('.send-travel-type').off().on('click', function _sendType(e) {
			var selected_type = $(this).data('type'),
				start_date    = '',
				end_date      = '',
				all_dates     = '',
				display_type  = 'suppliers';

			e.preventDefault();

			$('.travel-type-panel').each(function _disableTheRest() {
				if ($(this).data('type') !== selected_type) {
					$(this).find('.lp-panel-body').css('filter', 'grayscale(100%)');
					$(this).find('.send-travel-type').addClass('disabled');
					$(this).find('.panel-heading').css('background-color', '#666');
				}
			});

			if ($('#liveplannerprocessor-dates').is(':visible')) {
				all_dates  = $('#liveplannerprocessor-dates').val().split(' - ');
				start_date = formatDate(all_dates[0]);
				end_date   = formatDate(all_dates[1]);

				if (selected_type === 'cruise') {
					display_type = 'cruise lines';
				} else if (selected_type === 'ais') {
					display_type = 'all-inclusive brands';
				}

				$('.live-planner-container').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading ' + display_type + '...');

				Adzuki.Ajax.get('/LivePlanner/sendType/' + selected_type + '/' + start_date + '/' + end_date)
				.then(function _sendType(content) {
					$('.live-planner-container').html(content);

					Adzuki.Form.initAjaxForm('LivePlannerProcessor');
					Adzuki.LivePlanner.setPageGuide();
					Adzuki.LivePlanner.refreshLog();

					// hide the date selector on anything that isn't cruise right now
					switch (selected_type) {
						case 'ais':
						case 'fit':
							$('.lp-travel-dates').addClass('hidden');
						break;
						case 'cruise':
						default:
							$('.lp-travel-dates').removeClass('hidden');
						break;
					}

					$('.live-planner-container')
					.on('click', '.back-to-travel-types', function _backToTravelTypes(e) {
						e.preventDefault();

						Adzuki.LivePlanner.showAllTravelTypes();
					});
				});
			}
		});
	};

	function formatDate(date) {
		var d     = new Date(date),
			month = '' + (d.getMonth() + 1), // eslint-disable-line no-implicit-coercion
			day   = '' + d.getDate(), // eslint-disable-line no-implicit-coercion
			year  = d.getFullYear();

		if (month.length < 2) {
			month = '0' + month;
		}

		if (day.length < 2) {
			day = '0' + day;
		}

		return [year, month, day].join('-');
	}
}(jQuery, window.Adzuki || {}));
